<!-- [autoResize] basta cuando cambia la altura: ngx-echarts observa este mismo
     div con un ResizeObserver, que dispara igual por alto que por ancho. -->
<div echarts
     class="chart"
     [options]="themedOptions()"
     [style.height.px]="scaledHeight()"
     [autoResize]="true"></div>
